import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import type { MembershipDetails } from 'api-client';

interface MemberRemovalDialogProps {
  details: MembershipDetails;
  open: boolean;
  pending: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}
export default function MemberRemovalDialog({
  details,
  open,
  pending,
  error,
  onCancel,
  onConfirm,
}: MemberRemovalDialogProps) {
  const title = details.isSelf ? 'Leave Team' : 'Remove Member';
  return (
    <Dialog
      open={open}
      onClose={pending ? undefined : onCancel}
      fullWidth
      maxWidth="sm"
      aria-labelledby="member-removal-title"
    >
      <DialogTitle id="member-removal-title">{title}?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {details.isSelf
            ? `Leave ${details.team.name}?`
            : `Remove ${details.membership.displayName} from ${details.team.name}?`}{' '}
          Team access can be restored with a new invitation.
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        {details.removalBlockedReason && details.removalBlockedReason !== error && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            {details.removalBlockedReason}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={pending}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          disabled={pending || !details.canRemove}
          startIcon={pending ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {pending ? 'Removing…' : title}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
